import {useParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import socket from "../utils/clientSocket";
import {fetchFriendMessages} from "../clients/FriendClient";
import {useUser} from "../UserContext";
import UnauthorizedMessage from "../components/UnauthorizedMessage";

const FriendChat = () => {
    const {friendName} = useParams()
    const [messages, setMessages] = useState([])
    const [chatInput, setChatInput] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)
    const bottomAnchor = useRef(null)
    //TODO At some point make this changeable, so we can go further back in chat
    const pageNo = useRef(1)
    const user = useUser();

    const sendMessage = () => {
        if (!chatInput.trim()) return;
        const newMsg = {message: chatInput.trim(), friendName, timeSent: new Date(Date.now())};
        newMsg.senderName = user.username;
        socket.emit('friendMessage', newMsg);
        setMessages(prevState => [...prevState, newMsg]);
        setChatInput("");
    };

    const getPreviousMessages = () => {
        fetchFriendMessages(friendName, pageNo.current)
            .then((messages) => {
                const formattedMessages = messages.map(message => {
                    message.timeSent = new Date(message.timeSent);
                    return message
                })
                setMessages(formattedMessages);
            })
            .catch(handleError)
    }

    const handleError = (error) => {
        setErrorMessage(error.response?.data?.message || error.message)
    }

    useEffect(() => {
        getPreviousMessages();
        socket.on("friendMessage", (message) => {
            message.timeSent = new Date(message.timeSent)
            setMessages((prevMessages) => [...prevMessages, message])
        })

        return () => {
            socket.off("friendMessage")
        }
    }, []);

    useEffect(() => {
        bottomAnchor.current?.scrollIntoView({block: "nearest"})
    }, [messages])

    return (
        user.isLoggedIn ?
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: "1rem"}}>
                <div style={{width: "80vw"}}>
                    <div
                        className="messages"
                        style={{
                            marginBottom: '0.5rem',
                            backgroundColor: "#fff",
                            height: "70vh",
                            overflowX: "hidden",
                            boxShadow: '0 0.15rem 0.4rem rgba(0, 0, 0, 0.15)'
                        }}
                    >
                        {messages.map((msg, idx) => (
                            <div key={idx} className="message"
                                 style={{fontSize: "0.75rem", fontFamily: "sans-serif", color: "#555"}}>
                                <p style={{
                                    margin: "0",
                                    color: "#666",
                                    fontSize: "0.5rem"
                                }}>{msg.timeSent.toLocaleTimeString('en-GB')}</p>
                                <strong style={{marginRight: "0.2rem"}}>{msg.senderName}:</strong> {msg.message}
                            </div>
                        ))}
                        <input
                            type="text"
                            value={chatInput}
                            onChange={(e) => setChatInput(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') sendMessage();
                            }}
                            placeholder="Type a message..."
                            style={{
                                flex: 1,
                                fontSize: "0.8rem",
                                borderTop: "1px solid #ccc",
                                borderBottom: "1px solid #ccc",
                                borderRight: "none",
                                borderLeft: "none",
                                width: "100%"
                            }}
                        />
                        <div ref={bottomAnchor}/>
                    </div>
                    <button
                        onClick={sendMessage}
                        className="send-button"
                        style={{fontSize: "inherit", alignSelf: "flex-start"}}
                    >
                        Send
                    </button>
                </div>


            </div> :
            <UnauthorizedMessage/>

    )
}

export default FriendChat;